import { render, staticRenderFns } from "./node5.vue?vue&type=template&id=0ef6c778&scoped=true&"
import script from "./node5.vue?vue&type=script&lang=js&"
export * from "./node5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef6c778",
  null
  
)

export default component.exports